import React, {useState, useEffect} from 'react';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { resetPassword } from '../services/Password';

export default function ForgotPassword() {
  const [username, setUsername] = useState('');
  const is_logged_in = useSelector(state => state.app.is_logged_in);
  const history = useHistory();

  useEffect(() => {
    if (is_logged_in) {
      history.push("/");
    }
  }, [is_logged_in, history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    resetPassword(username)
    .then(response => {
      if (response.success) {
        window.alert('Ready, Set, Reset: Back in the Game. We will send you a password reset link soon.');
        history.push("/");
      } else if (response.errors) {
        window.alert(response.errors);
      }
    });
  };

  return (
    <>

      <div className="row pt-5 mt-5">
        <div className="col-12">
          <h1 className="text-center">Password Reset - Because Memory Fails Us</h1>
          <p className="text-center">Forgot your magic word? It happens to the best of us. We'll fix it.</p>
        </div>
      </div>
    <Form id="signup" className="row d-flex justify-content-center mx-3" onSubmit={handleSubmit}>
      <div className="col-12 col-md-6 mx-auto bg-white shadow rounded py-3 m-3 m-sm-0">
      <p className="text-center">Enter your email address below, and we will send you a link you can use to reset your password.</p>
        <Form.Group className="col-12">
          <Form.Label>Email</Form.Label>
          <Form.Control type="input" onChange={(e) => setUsername(e.target.value)} value={username}/>
        </Form.Group>
        <div className="col-12">
          <Button type="submit" variant="danger btn-lg w-100 text-uppercase mt-4">Submit</Button>
        </div>
      </div>
    </Form>

    </>
  );
}
